/**
 * Feb 27, 2026 · Fulfillment Type helper.
 *
 * MRQs and Child WOs are tagged by department into two lanes:
 *   • Warehouse Fulfillment  → Warping · Weaving        (issued from RM Store)
 *   • Internal Handoff       → Covering · Spandex Warping (received from an upstream floor)
 * A single source of truth for the classifier and badge styling so
 * every screen (Requisitions, Material Issue, Child WO summary, WO
 * summary) shows the same label + colour.
 */
export const WAREHOUSE_DEPTS = ["Warping", "Weaving"];
export const INTERNAL_DEPTS  = ["Covering", "Spandex Warping"];

export const FULFILLMENT_WAREHOUSE = "Warehouse Fulfillment";
export const FULFILLMENT_INTERNAL  = "Internal Handoff";

export function fulfillmentType(department) {
  if (!department) return "";
  if (WAREHOUSE_DEPTS.includes(department)) return FULFILLMENT_WAREHOUSE;
  if (INTERNAL_DEPTS.includes(department))  return FULFILLMENT_INTERNAL;
  return "";
}

export const FULFILLMENT_BADGE = {
  [FULFILLMENT_WAREHOUSE]: "border-sky-500/50 text-sky-300 bg-sky-500/10",
  [FULFILLMENT_INTERNAL]:  "border-purple-500/50 text-purple-300 bg-purple-500/10",
};
